module.exports = __webpack_public_path__ + "img/img4.cb076631.svg";